import alprestamo from "../providers/alprestamo";
import pml from "../providers/pml";

/**
 * Runner
 * Se configuran los disparos de cada pixel por ruta para cada motor
 * Los pixeles que requieran un enable() o init() se deben configurar en el método correspondiente aquí también
 * Pasar el context siempre
 */
const PixelesMotor = {
  enable() {},
  init() {},
  wait() {
    return true;
  },
  paso3() {
    alprestamo.enviar();
    pml.enviar();
  }
};

export default PixelesMotor;
